import type { AdminGigListItemResponse } from "../../../types/adminTypes";
import { formatDate, formatDateInGigTimeZone } from "../../../utils/DateUtils";
import { formatGigCompensation } from "../../../utils/GigCompensationUtils";
import { formatCityStateZip } from "../../../utils/LocationUtils";
import Button from "../../ui/Button/Button";
import AdminPillBadge from "../ui/AdminPillBadge";

type AdminGigsTableRowProps = {
  gig: AdminGigListItemResponse;
  onView: (gig: AdminGigListItemResponse) => void;
};

const statusTone: Record<AdminGigListItemResponse["status"], "neutral" | "success" | "warning" | "danger"> = {
  DRAFT: "neutral",
  PUBLISHED: "success",
  FILLED: "warning",
  CANCELLED: "danger",
};

const AdminGigsTableRow = ({ gig, onView }: AdminGigsTableRowProps) => {
  return (
    <tr className="align-top">
      <td className="px-4 py-4 text-sm text-myteengig-text-primary">
        <div className="space-y-1">
          <p className="font-semibold">{gig.title}</p>
          <p className="text-myteengig-text-muted">{gig.category}</p>
          <p className="text-xs text-myteengig-text-muted">
            {gig.startTime ? `Starts ${formatDateInGigTimeZone(gig.startTime, gig.timeZone)}` : "No schedule set"}
          </p>
        </div>
      </td>
      <td className="px-4 py-4 text-sm text-myteengig-text-primary">
        <div className="space-y-1">
          <p className="font-semibold">
            {[gig.posterFirstName, gig.posterLastName].filter(Boolean).join(" ") || "Unknown poster"}
          </p>
          <p className="text-myteengig-text-muted">{gig.posterEmail ?? "No email"}</p>
        </div>
      </td>
      <td className="px-4 py-4 text-sm text-myteengig-text-primary">
        <div className="space-y-2">
          <AdminPillBadge tone={statusTone[gig.status]}>{gig.status}</AdminPillBadge>
          {gig.blocked ? <AdminPillBadge tone="danger">Blocked</AdminPillBadge> : null}
          <p className="text-xs text-myteengig-text-muted">Updated {formatDate(gig.updatedAt)}</p>
        </div>
      </td>
      <td className="px-4 py-4 text-sm text-myteengig-text-primary">{formatCityStateZip(gig)}</td>
      <td className="px-4 py-4 text-sm text-myteengig-text-primary">{formatGigCompensation(gig.paymentAmountCents, gig.volunteer)}</td>
      <td className="px-4 py-4 text-sm text-myteengig-text-primary">{formatDate(gig.createdAt)}</td>
      <td className="px-4 py-4 text-sm text-myteengig-text-primary">
        <Button variant="outline" size="sm" onClick={() => onView(gig)}>
          View
        </Button>
      </td>
    </tr>
  );
};

export default AdminGigsTableRow;
